module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_12-51b768ae09828db569b45e24a592aaa6.jpg";